import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import { captureAndStripTravelRuleResult } from "./utils/travelRuleResultFragment";

// Notabene's hosted Travel Rule page redirects back with its result — including
// counterparty PII — in the URL fragment. Strip it before anything renders:
// `App` initialises Amplitude (pageViews autocapture + session replay) and the
// Adora recorder in its component body, all of which capture `location.href`.
captureAndStripTravelRuleResult();

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root"),
);
